export default __webpack_public_path__ + "static/media/search.c721e892.svg";